import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTransaction } from "../../reduxStore/entities/transactionDetails";

import { Responsive, WidthProvider } from "react-grid-layout";
import Layout from "../../core/Layout";
import TransactionBasicInfo from "./TransactionBasicInfo";
import useLocalStorage from "../../hooks/useLocalStorage";
import { TRANSACTION_DETAILS_LAYOUT_KEY, defaultLayout } from "../../common/TransactionDetailsLayout";
import { useIdParam } from "../../hooks/useIdParam";

const ResponsiveGridLayout = WidthProvider(Responsive);

const TransactionDetails = (props) => {
    const dispatch = useDispatch();
    const id = useIdParam();

    const [lsLayout, setLsLayout] = useLocalStorage(TRANSACTION_DETAILS_LAYOUT_KEY, defaultLayout);

    React.useEffect(() => {
        dispatch(getTransaction(id));
        return () => { };
    }, []);

    return (
        <Layout>
            <ResponsiveGridLayout
                className="layout"
                cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
                rowHeight={30}
                layouts={lsLayout}
                isDraggable={false}
                onLayoutChange={(layout, layouts) => {
                    setLsLayout(layouts);
                }}
            >
                <div key="1">
                    <TransactionBasicInfo />
                </div>
                {/* <div key="2">
                    <TransactionHistory />
                </div> */}
            </ResponsiveGridLayout>
        </Layout>
    );
};

export default TransactionDetails;
